<template>
	<app-badge :theme="theme" size="medium" class="w-full flex flex-col mb-3">
		<p class="w-full mb-2">
			{{ journey.link_number }} || {{ journey.journey_number }} ||
			{{ journey.delivery_time }} || {{ journey.delivery_postcode }} ||
			{{ Number(journey.weight).toFixed(4) }}t
		</p>
		<p class="font-semibold uppercase w-full">
			{{ journey.account_name }}
		</p>
	</app-badge>
</template>

<script lang="ts" setup>
	import type { Journey } from '@/data/schema/journey'
	import { computed } from 'vue'

	const props = withDefaults(
		defineProps<{
			journey: Journey
		}>(),
		{}
	)

	const theme = computed(() => {
		switch (props.journey.type) {
			case 'DEL':
				return 'success'
			case 'COL':
				return 'neutral'
			case 'TOS':
				return 'primary'
			default:
				return 'primary'
		}
	})
</script>
